import { cx } from '@linaria/core';
import { Link } from '@provider/navigation';
import { resets } from '@ui/css';
import { wrapper, modifiers } from './pill.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Pill({
  active,
  icon,
  iconOnly,
  size,
  theme,
  activeTheme,
  as,
  ...props
}) {
  const Comp = as === "a" ? Link : "button";
  return /*#__PURE__*/jsxs(Comp, {
    ...props,
    // @ts-expect-error Poorly typed polymorphic component
    ref: props.ref,
    className: cx(resets.rootCls, wrapper, (iconOnly || !props.children) && modifiers.noContent.className, !!icon && modifiers.withIcon.className, props.className, active && "active"),
    "data-size": size,
    "data-theme": theme,
    "data-active-theme": activeTheme,
    children: [icon, !!props.children && /*#__PURE__*/jsx("span", {
      children: props.children
    })]
  });
}

export { Pill };
//# sourceMappingURL=pill.js.map
